import React from "react";
import { Text, Flex } from "@thenounproject/lingo-core";

import { Container, InnerMedium } from "../Elements";
import Header from "../header/Header";
import Footer from "../Footer";
import CookieConsent from "../CookieConsent";

export default function NotFound() {
  return (
    <>
      <Header />
      <Container mt="xxl">
        <InnerMedium>
          <Flex flexDirection="column" width="100%" textAlign="center" my="15vh">
            <Text as="h1" font="marketing.h1" mb="m">
              404
            </Text>
            <Text font="marketing.bodyLarge" color="grayDarker">
              Oops, we couldn&apos;t find that page.
            </Text>
          </Flex>
        </InnerMedium>
      </Container>
      <Footer />
      <CookieConsent />
    </>
  );
}
